import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Spinner from '@components/spinner'
import { formatDateToDate } from '@atheneum/api/dist/lib'
import '../Sidebar.sass'

import ProjectSidebarStore from '../stores/projectSidebar.store'

class ProjectSidebar extends Component {
  static propTypes = {
    id: PropTypes.number,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object
  }

  constructor(props) {
    super(props)

    const { id, staticData } = props
    this.projectSidebarStore = new ProjectSidebarStore(staticData)
    this.projectSidebarStore.load(id)
  }

  renderLoader() {
    return <Spinner />
  }

  renderClientContacts = () => {
    const { project } = this.projectSidebarStore

    if (project.clients.length < 1) return '-'
    return project.clients.map(client => {
      return (
        <p key={client.id}>
          {client.title} {client.fullName}
        </p>
      )
    })
  }

  render() {
    const {
      project,
      segments,
      industry,
      subIndustry,
      projectBackground,
      loading
    } = this.projectSidebarStore
    if (loading) return this.renderLoader()
    if (!project) return null
    return (
      <div>
        <h1 onClick={() => this.props.sidebarStore.closeSidebar()}>
          <Link to={`/project/${project.id}`}>{project.projectName}</Link>
        </h1>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Start - End date
          </span>
          <p>{formatDateToDate(project.startDate, project.endDate)}</p>
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Atheneum code
          </span>
          <p>{project.atheneumCode}</p>
        </div>
        <h2>Client details</h2>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Client account
          </span>
          <p>{project.office.account.companyName}</p>
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Client office
          </span>
          <p>{project.office.officeName}</p>
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Client contacts
          </span>
          <div>{this.renderClientContacts()}</div>
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Case code
          </span>
          <p>{project.caseCode ? project.caseCode : '-'}</p>
        </div>
        <h2>Project details</h2>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Industry and subindustry
          </span>
          <div className='sidebar-wrapper__rich-text rich-text--dark'>
            {industry}/{subIndustry}
          </div>
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            EM
          </span>
          <div className='sidebar-wrapper__rich-text rich-text--dark'>
            {project.engagementManager}
          </div>
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            EC
          </span>
          <div className='sidebar-wrapper__rich-text rich-text--dark'>
            {project.engagementCode}
          </div>
        </div>
        {
          project.projectLeadName &&
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              Project lead name
          </span>
            <div className='sidebar-wrapper__rich-text rich-text--dark'>
              {project.projectLeadName}
            </div>
          </div>
        }
        {
          project.projectLeadEmail &&
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              Project lead email
          </span>
            <div className='sidebar-wrapper__rich-text rich-text--dark'>
              {project.projectLeadEmail}
            </div>
          </div>
        }
        {
          project.projectDirectorName &&
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              Project director name
          </span>
            <div className='sidebar-wrapper__rich-text rich-text--dark'>
              {project.projectDirectorName}
            </div>
          </div>
        }
        {
          project.projectDirectorEmail &&
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              Project director email
          </span>
            <div className='sidebar-wrapper__rich-text rich-text--dark'>
              {project.projectDirectorEmail}
            </div>
          </div>
        }
        {
          project.projectLocationName &&
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              Project Location Name
          </span>
            <div className='sidebar-wrapper__rich-text rich-text--dark'>
              {project.projectLocationName}
            </div>
          </div>
        }
        {
          project.projectLocationAddress &&
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              Project Location Address
          </span>
            <div className='sidebar-wrapper__rich-text rich-text--dark'>
              {project.projectLocationAddress}
            </div>
          </div>
        }
        {
          project.projectLocationCountry &&
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              Project Location Country
          </span>
            <div className='sidebar-wrapper__rich-text rich-text--dark'>
              {project.projectLocationCountry}
            </div>
          </div>
        }
        {
          project.capiProjectType &&
          <div className='group'>
            <span className='sidebar-wrapper__content__label--default'>
              Project Type
          </span>
            <div className='sidebar-wrapper__rich-text rich-text--dark'>
              {project.capiProjectType && (project.capiProjectType === 'LOP' ? <strong>{project.capiProjectType}</strong> : project.capiProjectType)}
            </div>
          </div>
        }
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Background
          </span>
          <div
            className='sidebar-wrapper__rich-text rich-text--dark'
            dangerouslySetInnerHTML={{ __html: projectBackground }}
          />
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Segment title and required experts
          </span>
          {segments.map(segment => {
            return (
              <p
                key={segment.id}
                className='sidebar-wrapper__rich-text rich-text--dark'
              >
                {segment.name} (
                {segment.numberOfExpert ? segment.numberOfExpert : '0'})
              </p>
            )
          })}
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Blacklisted companies
          </span>
          <div
            className='sidebar-wrapper__rich-text rich-text--dark'
            dangerouslySetInnerHTML={{
              __html: project.blacklistedCompanies || '-'
            }}
          />
        </div>
        <div className='group'>
          <span className='sidebar-wrapper__content__label--default'>
            Invoicing instructions
          </span>
          <div
            className='sidebar-wrapper__rich-text rich-text--dark'
            dangerouslySetInnerHTML={{
              __html: project.invoicingInstructions || '-'
            }}
          />
        </div>
      </div>
    )
  }
}

export default inject('sidebarStore', 'staticData')(observer(ProjectSidebar))
